export default __webpack_public_path__ + "static/media/server.693cf470.svg";